<template>
  <v-dialog
    v-model="isVisible"
    class="confirm-dialog"
    persistent
    width="500"
  >
    <v-card class="confirm-dialog elevation-3">
      <v-card-title>
        <slot name="title">
          {{ title }}
        </slot>
      </v-card-title>

      <v-card-text
        class="pt-6"
      >
        <slot name="message">
          {{ message }}
        </slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <slot name="actions">
          <div
            class="d-flex"
            :class="{'flex-row-reverse': invertActionButtons}"
          >
            <v-btn
              :color="cancelButtonColor"
              :disabled="isLoading"
              text
              type="button"
              @click="notifyUserCanceled"
            >
              {{ cancelButtonLabel }}
            </v-btn>

            <v-btn
              :color="confirmButtonColor"
              :loading="isLoading"
              text
              type="button"
              @click="notifyUserConfirmed"
            >
              {{ confirmButtonLabel }}
            </v-btn>
          </div>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',

  model: {
    prop: 'visible',
    event: 'change',
  },

  props: {
    cancelButtonColor: {
      type: String,
      default: 'secondary',
    },

    cancelButtonLabel: {
      type: String,
      default: 'Cancel',
    },

    confirmButtonColor: {
      type: String,
      default: 'primary',
    },

    confirmButtonLabel: {
      type: String,
      default: 'Confirm',
    },

    invertActionButtons: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    message: {
      type: String,
      default: 'Are you sure?',
    },

    title: {
      type: String,
      default: 'Confirm Action',
    },

    visible: {
      type: Boolean,
      required: true,
    },
  },

  data () {
    return {
      intLoading: false,
    }
  },

  computed: {
    isLoading: {
      get () {
        return this.loading || this.intLoading
      },

      set (value) {
        this.intLoading = value === true
      },
    },

    isVisible: {
      get () {
        return this.visible
      },

      set (value) {
        this.$emit('change', value === true)
      },
    },
  },

  watch: {
    visible (isVisible, wasVisible) {
      if (isVisible === wasVisible) return
      if (isVisible === true) this.intLoading = false
    },
  },

  methods: {
    notifyUserCanceled () {
      this.isVisible = false
      this.$emit('canceled')
    },

    notifyUserConfirmed () {
      this.isLoading = true
      this.$emit('confirmed')
    },
  },
}
</script>
